import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "modal-header" }
const _hoisted_3 = {
  class: "modal-title",
  id: "pdf-viewer-modal-label"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("span", { "aria-hidden": "true" }, "×", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/_createElementVNode("i", { class: "far fa-window-maximize" }, null, -1)
const _hoisted_7 = [
  _hoisted_6
]
const _hoisted_8 = {
  key: 0,
  class: "modal-body"
}
const _hoisted_9 = ["src"]
const _hoisted_10 = {
  key: 1,
  style: {"height":"60vh","width":"100%"}
}
const _hoisted_11 = ["src"]

import { computed, ref, PropType, reactive, onMounted } from 'vue';
import { Document } from "@/models";
import { VueFinalModal, useVfm } from 'vue-final-modal';
import VueDragResize from 'vue3-drag-resize';
import 'vue-final-modal/style.css';

export default /*#__PURE__*/_defineComponent({
  __name: 'DraggableModal',
  props: {
  modalId: { type: String as PropType<string>, default: '' },
  name: { type: String as PropType<string>, default: '' },
  document: { type: Document as PropType<Document> },
  title: { type: String as PropType<string>, default: '' },
  modalkey: { type: String as PropType<string>, default: '' },
},
  emits: ["update:modelValue"],
  setup(__props, { expose: __expose, emit: __emit }) {

const vfm = useVfm();

const emit = __emit

const props = __props;
const position = reactive({
  x: 0, // initial x position
  y: 0, // initial y position
});

const width = ref(0)
const height = ref(0)
const top = ref(0)
const left = ref(0)
function dragResize(newRect: any) {
  width.value = newRect.width
  height.value = newRect.height
  top.value = newRect.top
  left.value = newRect.left
}
const openseparate = () => {
  hide();
  window.open(props.document.src);
};

const dynaWidth = ref(window.innerWidth*.8);
const dynaHeight = ref(window.innerHeight*.6);

// Computed properties
const documentsrc = computed(() => {
  let src = props.document.src;
  let filextension = props.document?.src?.toLocaleLowerCase();
  if (filextension?.endsWith("doc") || filextension?.endsWith("docx")) {
    src = `https://docs.google.com/gview?url=${props.document.src}&embedded=true`;
  }
  return src;
});

const getDocumenttype = computed(() => {
  let filename = props.document?.src?.toLocaleLowerCase();
  return (filename.endsWith('jpg') || filename.endsWith('png')) ? 'image' : 'document';
});
// Center the component on mount
onMounted(() => {
  const screenWidth = window.innerWidth;
  const screenHeight = window.innerHeight;
  position.x = (screenWidth - dynaWidth.value) / 2;
  position.y = (screenHeight - dynaHeight.value) / 2;
});
const hide = () => {
  vfm.close(props.modalId);
};
__expose({hide });


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(VueFinalModal), {
    class: "confirm-modal",
    "content-class": "confirm-modal-content",
    "overlay-transition": "vfm-fade",
    "content-transition": "vfm-fade",
    "display-directive": "show",
    background: "interactive",
    "hide-overlay": true,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = (val) => emit('update:modelValue', val)),
    "modal-id": __props.modalId
  }, {
    default: _withCtx(() => [
      _createVNode(_unref(VueDragResize), {
        "is-active": false,
        isResizable: false,
        w: dynaWidth.value,
        h: dynaHeight.value,
        x: position.x,
        y: position.y,
        class: "bg-primary-100 dark:bg-gray-800",
        onDragging: dragResize
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("h5", _hoisted_3, _toDisplayString(__props.title), 1),
              _createElementVNode("div", null, [
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Close",
                  onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (hide()), ["prevent"]))
                }, _hoisted_5),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  "aria-label": "Open in new window",
                  onClick: _withModifiers(openseparate, ["prevent"])
                }, _hoisted_7)
              ])
            ]),
            (__props.document && __props.document.src)
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  (getDocumenttype.value != 'image')
                    ? (_openBlock(), _createElementBlock("iframe", {
                        class: "document-iframe",
                        key: __props.modalkey,
                        src: documentsrc.value,
                        style: {"height":"60vh","width":"100%"},
                        frameborder: "0"
                      }, null, 8, _hoisted_9))
                    : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                        _createElementVNode("img", {
                          src: documentsrc.value,
                          style: {"height":"100%","width":"100%"}
                        }, null, 8, _hoisted_11)
                      ]))
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["w", "h", "x", "y"])
    ]),
    _: 1
  }, 8, ["modal-id"]))
}
}

})